import {BarDatum} from '@nivo/bar';
import {IElementQuestionnaire, IElementQuestionnaireWithAnswers} from '../../../../../incase-domain/elements/base/questionElementBase';
import {QuestionAnswerEnum, QuestionAnswerType, QuestionReport, QuestionReportAnswer} from '../../../../../incase-domain/analytics';
import {IElementLikertScale} from '../../../../../incase-domain/elements/question/likertScale';

export const determineQuestionDebatability = (element: IElementQuestionnaire, questionReport?: QuestionReport): boolean => {
    return element.isDebatable || questionReport?.isDebatable || false;
};

export const getAnswerStatus = (
    answer: QuestionReportAnswer,
    element: IElementQuestionnaire,
    questionReport?: QuestionReport
): QuestionAnswerType => {
    const isDebatable = determineQuestionDebatability(element, questionReport);
    const elementAnswer =
        'answers' in element
            ? (element as IElementQuestionnaireWithAnswers).answers?.find((ans) => ans.text === answer.answerText)
            : undefined;

    if (isDebatable || elementAnswer?.type === QuestionAnswerEnum.DEBATABLE) {
        return QuestionAnswerEnum.DEBATABLE;
    }

    return (answer.type ?? QuestionAnswerEnum.INCORRECT) as QuestionAnswerType;
};

export const isLikertScaleElement = (element: IElementQuestionnaire): element is IElementLikertScale => {
    return 'questions' in element && 'scale' in element;
};

export function transformLikertScaleData(likertScaleData: BarDatum[], element: IElementLikertScale): number[][] {
    const scaleLength = element.scale.length;

    return likertScaleData.map((questionData) => {
        const scaleCounts: {[key: number]: number} = {};
        let totalResponses = 0;

        Object.keys(questionData).forEach((key) => {
            const numKey = parseInt(key);
            const value = questionData[key];

            if (!Number.isNaN(numKey) && typeof value === 'number') {
                scaleCounts[numKey] = value;
                totalResponses += value;
            }
        });

        const percentages: number[] = [];
        for (let i = 0; i < scaleLength; i++) {
            const scaleValue = i + 1;
            const count = scaleCounts[scaleValue] || 0;
            const percentage = totalResponses > 0 ? count / totalResponses : 0;
            percentages.push(percentage);
        }

        return percentages;
    });
}
